export default "__VITE_ASSET__qQyUtDSl__"